import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import * as THREE from 'three';

export default class Scene extends THREE.Scene {
	constructor() {
		super();

		this.canvas = document.querySelector('canvas.webgl');

		this.setScene();
	}
	updateCameraForDevice() {
		const w = window.innerWidth;
		const h = window.innerHeight;
		const isMobile = w <= 1.25*h;
		// const isMobile = true;

		// 每次都要更新 aspect
		this.camera.aspect = w / h;

		if (isMobile) {
			// ✅ 手机用更远/更高一点，避免画面太挤
			this.camera.fov = 75;                // 可选：手机稍微大一点视野
			this.camera.position.set(-3.53, 1.34, 3.09);   // 你要的“不同摄像机位置”
			this.controls.target.set(-3.14, -0/34, 0.9);

		} else {
			// ✅ 桌面端保持你现在的效果
			this.camera.fov = 75;
			this.camera.position.set(2.57, 0.91, 3.18);
			this.controls.target.set(0.11,-0.5,0.03);

		}

		this.camera.updateProjectionMatrix();
	}
	setResize() {
		window.addEventListener('resize', () => {
			// renderer
			this.renderer.setSize(window.innerWidth, window.innerHeight);
			this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

			// camera
			this.updateCameraForDevice();
		});
	}



	setScene() {
		this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, .1, 100);
		// this.camera.position.set(2.57, 0.91, 3.18);

		this.setLights();
		this.setRenderer();
		this.setControls();
		this.updateCameraForDevice();
		this.setResize();
	}

	setLights() {
		this.light = new THREE.HemisphereLight(0xffffff, 0x404040, 1);
		this.add(this.light);
	}

	setRenderer() {
		this.renderer = new THREE.WebGLRenderer({
			antialias: true,
			canvas: this.canvas
		});
		this.renderer.setSize(window.innerWidth, window.innerHeight);
		this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
	}

	setControls() {
		this.controls = new OrbitControls(this.camera, this.canvas);
		this.controls.enabled = false;
		this.controls.enableDamping = true;
		// this.controls.target.set(0.11,-0.5,0.03);
		this.controls.update();
	}
}
